
<template>
  <router-view />
</template>

<script setup lang="ts">
//import { computed } from 'vue'
// import { useThemeStore } from './stores/themeStore'


// const themeStore = useThemeStore()
// const appThemeClass = computed(() => {
//   return themeStore.isDark ? "bg-dark text-light" : "bg-white text-dark"
// });

</script>

<style scoped>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  min-height: 100vh;
  padding-top: 0px;
  max-width: 2240px;
  width: 100%;
  margin: 0 auto;
  text-align: left;
  box-sizing: border-box;  
}

.container {
  max-width: 2240px !important;
  padding-left: 1rem;
  padding-right: 1rem;
  min-height: calc(100vh - 56px);
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .with-navbar-offset {
    padding-top: 70px;
  }
}

.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
